import React, {useState} from "react";
import {useRecoilValue} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import useFetchHelp from "../../hooks/useFetchHelp";
import { useTranslation } from "react-i18next";

export default function HelpModal() {
  const {t} = useTranslation('lounge')
  const activeModal = useRecoilValue(activeModalState);
  const help = useFetchHelp();

  const [helpIndex, setHelpIndex] = useState(null);
  const helpItem = help.data?.topics?.[helpIndex];

  return (
    <BaseModal show={activeModal === 'faq'} title={t('help')}>
      {helpIndex !== null ? (
        <div>
          <div className="mb-2">
            <button className="text-yellow-500 hover:underline text-sm font-semibold" onClick={() => {
              setTimeout(() => setHelpIndex(null), 1)
            }}><i className="fas fa-chevron-left fa-fw"></i> {t('back')}</button>
          </div>
          <div className="w-full">
            <h4 className="font-bold mb-1">{helpItem?.label}</h4>
            <div className="text-sm" dangerouslySetInnerHTML={{__html: helpItem?.body}} />
          </div>
        </div>
      ) : (
        <div>
          <a href={help.data?.link} target="_blank" className="block text-center bg-green-500 hover:bg-green-600 duration-100 ease-in w-full p-3 text-white mb-3 rounded-full"><i className="fas fa-comments"></i> {t('need-help')}</a>
          {help.data?.topics?.length > 0 && <hr className="mb-3"/>}
          {help.data?.topics?.length > 0 && (
            <p className="text-center text-sm mb-3 px-3 font-medium">
              {help.data?.introduction}
            </p>
          )}
          {help.data?.topics && help.data.topics.map((item, index) => (
            <div key={"help" + index} onClick={(e) => {
              setTimeout(() => setHelpIndex(index), 1);
            }}>
              <button type={"button"} className="bg-gray-200 rounded-lg p-4 mb-2 w-full text-sm text-left font-semibold hover:bg-gray-300 duration-100 ease-in">
                {item.label}
              </button>
            </div>
          ))}
        </div>
      )}
    </BaseModal>
  );
}
